/**
 * Module errors.
 *
 * @module
 */
/** Container resource not found in account */
export const ECONTAINER_NOT_PUBLISHED = {
  code: 1,
  name: "ECONTAINER_NOT_PUBLISHED",
  doc: "Container resource not found in account",
} as const;
